import { useEffect, useState } from "react"
import { Table, Form, Row, Col, InputGroup } from "react-bootstrap"
import { getEstimatedPercentageOfCompanyTotalRevenues } from "../../../data/enumSlice"
import { useDispatch, useSelector } from "react-redux"
import { actions } from "../../../data/applicationSlice"

const { updateApplicationData } = actions

const EstimatedProjectsRevenues = ({ questionNumber, validationError, setValidationErrors }) => {
    const [columnsData, setColumnsData] = useState([])
    const dispatch = useDispatch()
    const { application, fetchStatus } = useSelector((state) => state.application)
    const { estimatedPercentageOfCompanyTotalRevenues } = useSelector((state) => state.enums)
    const [totalPercent, setTotalPercent] = useState(0)
    const [leftColumnData, setLeftColumnData] = useState([])
    const [rightColumnData, setRightColumnData] = useState([])

    useEffect(() => {
        dispatch(getEstimatedPercentageOfCompanyTotalRevenues())
    }, [])

    useEffect(() => {
        if (validationError?.companyTotalRevenuesTotalPercentage && totalPercent === 100) {
            setValidationErrors((preErrors) => {
                const newError = { ...preErrors }
                if (newError["companyTotalRevenuesTotalPercentage"]) {
                    delete newError["companyTotalRevenuesTotalPercentage"]
                }
                return newError
            })
        }
    }, [totalPercent])

    useEffect(() => {
        let percent = 0
        columnsData?.forEach((item) => {
            if (item.key.includes("Label")) {
                return
            }
            const value = parseInt(application[item.key] ?? 0)

            if (!isNaN(value)) {
                percent += parseInt(value)
            }
        })

        percent += parseInt(application["companyTotalRevenueOther"] ?? 0)

        setTotalPercent(percent)
    }, [columnsData, fetchStatus])

    const handleInputChange = (event) => {
        const { value, name } = event.target

        if (name === "companyTotalRevenueOtherLabel") {
            dispatch(
                updateApplicationData({
                    field: "companyTotalRevenueOtherLabel",
                    value: value
                })
            )
            return
        }

        const numericValue = +value.replace(/\D/g, "")

        if (numericValue > 100) {
            alert("Percentages must be less than or equal to 100")
            return
        }

        dispatch(
            updateApplicationData({
                field: name,
                value: numericValue
            })
        )
    }

    useEffect(() => {
        const totalRevenues = Object.keys(application).filter((key) => key.startsWith("companyTotalRevenue"))

        const populatedRevenues = estimatedPercentageOfCompanyTotalRevenues?.map((item) => {
            const index = totalRevenues.findIndex((revenue) => revenue.key === item.key)
            if (index !== -1) {
                return { ...item, ...totalRevenues[index] }
            }
            return item
        })

        setLeftColumnData(populatedRevenues?.filter((item, index) => index % 2 === 0))
        setRightColumnData(populatedRevenues?.filter((item, index) => index % 2 !== 0))
        setColumnsData(populatedRevenues)
    }, [estimatedPercentageOfCompanyTotalRevenues, fetchStatus])

    return (
        <div className="mt-4 percentages">
            <h6
                className={`
            ${validationError?.companyTotalRevenuesTotalPercentage ? "text-error" : ""}
            `}>
                {questionNumber}. Please provide the estimated percentage of your Company’s total revenues derived from
                the following types of projects. Please note that percentages must add up to 100%.
            </h6>

            <Row>
                <Col className="p-0">
                    <Table
                        striped
                        bordered
                        hover
                        className="mt-2">
                        <thead>
                            <tr>
                                <th>Category</th>
                                <th>Estimated Percentage of Total Revenue of current calendar year</th>
                            </tr>
                        </thead>
                        <tbody>
                            {leftColumnData?.map((item, index) => (
                                <tr key={item.id}>
                                    <td className="align-middle">{item.name}</td>
                                    <td className="percentage-column">
                                        <InputGroup>
                                            <Form.Control
                                                className={`form-control-sm`}
                                                max={100}
                                                min={0}
                                                name={item.key}
                                                value={application[item.key] || ""}
                                                onChange={(e) => {
                                                    const copiedData = [...leftColumnData]
                                                    let index = copiedData?.findIndex((i) => i.id === item.id)

                                                    if (index !== -1) {
                                                        copiedData[index] = {
                                                            ...copiedData[index],
                                                            value: +e.target.value
                                                        }
                                                    }
                                                    setLeftColumnData(copiedData)
                                                    setColumnsData([...copiedData, ...rightColumnData])
                                                    handleInputChange(e)
                                                }}
                                            />
                                            <InputGroup.Text id="basic-addon2">%</InputGroup.Text>
                                        </InputGroup>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Col>
                <Col className="p-0">
                    <Table
                        striped
                        bordered
                        hover
                        className="mt-2">
                        <thead>
                            <tr>
                                <th>Category</th>
                                <th>Estimated Percentage of Total Revenue of current calendar year</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rightColumnData?.map((item, index) => (
                                <tr key={item.id}>
                                    <td className="align-middle">
                                        {item.name === "Other (please describe)" ? (
                                            <Form.Control
                                                type="text"
                                                className="form-control-sm"
                                                placeholder="Other (please describe)"
                                                value={
                                                    typeof application["companyTotalRevenueOtherLabel"] === "string"
                                                        ? application["companyTotalRevenueOtherLabel"]
                                                        : ""
                                                }
                                                name={item.name === "Other (please describe)" ? "name" : ""}
                                                onChange={(e) => {
                                                    let event = {
                                                        target: {
                                                            value: e.target.value,
                                                            name: "companyTotalRevenueOtherLabel"
                                                        }
                                                    }
                                                    handleInputChange(event)
                                                }}
                                            />
                                        ) : (
                                            item.name
                                        )}
                                    </td>
                                    <td className="percentage-column">
                                        <InputGroup>
                                            <Form.Control
                                                className={`form-control-sm`}
                                                max={100}
                                                min={0}
                                                value={
                                                    item.name === "Other (please describe)"
                                                        ? application["companyTotalRevenueOther"]
                                                        : application[item.key] || ""
                                                }
                                                onChange={(e) => {
                                                    const copiedData = [...rightColumnData]
                                                    let index = copiedData?.findIndex((i) => i.id === item.id)

                                                    copiedData[index] = {
                                                        ...copiedData[index],
                                                        value: +e.target.value
                                                    }
                                                    setRightColumnData(copiedData)
                                                    setColumnsData([...copiedData, ...leftColumnData])
                                                    let event = {
                                                        target: {
                                                            value: e.target.value,
                                                            name:
                                                                item.name === "Other (please describe)"
                                                                    ? "companyTotalRevenueOther"
                                                                    : item.key
                                                        }
                                                    }
                                                    handleInputChange(event)
                                                }}
                                            />
                                            <InputGroup.Text id="basic-addon2">%</InputGroup.Text>
                                        </InputGroup>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p className={totalPercent !== 100 ? "total-percent text-error" : "total-percent"}>
                        Total Percent: {totalPercent}%
                    </p>
                </Col>
            </Row>
        </div>
    )
}

export default EstimatedProjectsRevenues
